import { FileDown, FileText as FileTextIcon, ChevronDown } from "lucide-react";
import {
  DropdownMenu,
  DropdownMenuTrigger,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuLabel,
} from "@/components/ui/dropdown-menu";

export const JobReportMenu = ({ order, downloadJobReport }) => (
  <DropdownMenu>
    <DropdownMenuTrigger asChild>
      <button
        data-testid={`download-job-pdf-${order.id}`}
        onClick={(e) => e.stopPropagation()}
        title="Download job report (PDF)"
        className="hidden md:inline-flex p-1.5 hover:bg-[#e6f3ff] text-[#39678f] items-center"
      >
        <FileDown className="w-4 h-4" />
        <ChevronDown className="w-3 h-3 ml-0.5" />
      </button>
    </DropdownMenuTrigger>
    <DropdownMenuContent align="end" className="w-64">
      <DropdownMenuLabel className="text-[10px] subtitle uppercase tracking-[0.2em] text-[#50493b]">
        PDF Format
      </DropdownMenuLabel>
      <DropdownMenuSeparator />
      <DropdownMenuItem
        data-testid={`download-job-pdf-summary-${order.id}`}
        onClick={(e) => { e.stopPropagation(); downloadJobReport(order.job_number, "pdf", { includeCertificates: false }); }}
        className="cursor-pointer"
      >
        <FileTextIcon className="w-4 h-4 mr-2 text-[#39678f]" />
        <div>
          <div className="text-sm">Job Report only</div>
          <div className="text-[11px] text-[#50493b]">Summary cover page</div>
        </div>
      </DropdownMenuItem>
      <DropdownMenuItem
        data-testid={`download-job-pdf-full-${order.id}`}
        onClick={(e) => { e.stopPropagation(); downloadJobReport(order.job_number, "pdf", { includeCertificates: true }); }}
        className="cursor-pointer"
      >
        <FileDown className="w-4 h-4 mr-2 text-[#39678f]" />
        <div>
          <div className="text-sm">Job Report + Certificates</div>
          <div className="text-[11px] text-[#50493b]">Cover + every test certificate</div>
        </div>
      </DropdownMenuItem>
    </DropdownMenuContent>
  </DropdownMenu>
);
